import React from "react";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { changeDateFormate } from "./utility";

const DatePickerHooksReport = React.memo(
  ({ value, maxDate, minDate, onChange, isEmpty }) => {
    return (
      <>
        {isEmpty && <span className="isEmpty">---- -- --</span>}
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            fullWidth
            inputVariant="outlined"
            className={`reportDatePicker ${isEmpty ? "hide" : ""}`}
            format="yyyy-MM-dd"
            value={
              value ? changeDateFormate(value) : changeDateFormate(new Date())
            }
            maxDate={
              maxDate
                ? changeDateFormate(maxDate)
                : changeDateFormate(new Date())
            }
            minDate={minDate && changeDateFormate(minDate)}
            views={["year", "month", "date"]}
            onChange={onChange && onChange}
          />
        </MuiPickersUtilsProvider>
      </>
    );
  }
);

export default DatePickerHooksReport;
